import React, { Component, useEffect } from "react";
import { withTranslate } from "react-redux-multilingual";

// Custom Components
import HeaderFive from "./common/headers/header-five";
import FooterFour from "./common/footers/footer-four";

const App=(props)=> {
	    
		return (
			<div>
				<HeaderFive logoName={"eksplode.png"} />
				{props.children}
				<FooterFour logoName={"eksplode.png"} />
			</div>
		);
	
}

export default withTranslate(App);
